import React, { Component } from "react";
import PropTypes from "prop-types";

/**
 * The component
 * @type {Object}
 */
class Contribute extends Component {
  /**
   * Render
   * @return {ReactElement}
   */
  render() {
    return <div> Contribute </div>;
  }
}
Contribute.propTypes = {};
export default Contribute;



// WEBPACK FOOTER //
// ./src/tabs/Contribute.js